import { render, staticRenderFns } from "./WorkOpinionList.vue?vue&type=template&id=4ddaf3fc&scoped=true&"
import script from "./WorkOpinionList.vue?vue&type=script&lang=js&"
export * from "./WorkOpinionList.vue?vue&type=script&lang=js&"
import style0 from "./WorkOpinionList.vue?vue&type=style&index=0&id=4ddaf3fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddaf3fc",
  null
  
)

export default component.exports